import ApiService from '@/services/api';

// TYPES
export type TProjectExportManualResponse = {
  data: string;
  status: number;
};
// FUNCTION
export const projectExportManual = async (lang: string): Promise<TProjectExportManualResponse> => {
  const endpoint = `v1/companies/manual/`;
  const response = await ApiService.get(endpoint, { params: { lang } });
  return response;
};
